export const WORD_SEARCHING = 'word.SEARCHING';
export const WORD_SEARCHED = 'word.SEARCHED';
export const WORD_SEARCH_ERROR = 'word.SEARCH_ERROR';



// WEBPACK FOOTER //
// ./src/stores/word_search/action_types.js